module.exports = __webpack_public_path__ + "img/errorIcon.ebeb0c76.svg";